var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMovieEditBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0097 16.7236C18.3448 16.3912 17.5625 16.8747 17.5625 17.618V30.382C17.5625 31.1253 18.3448 31.6088 19.0097 31.2764L31.7736 24.8944C32.5107 24.5259 32.5107 23.4741 31.7736 23.1056L19.0097 16.7236Z",
    fill: "#2196F3",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5625 8H38.5625V10H42.5625V8ZM32.1625 8H36.1625V10H32.1625V8ZM25.7625 8H29.7625V10H25.7625V8ZM19.3625 8H23.3625V10H19.3625V8ZM12.9625 8H16.9625V10H12.9625V8ZM6.5625 8H10.5625V10H6.5625V8ZM6.5625 36V12H42.5625V36H6.5625ZM6.5625 38V40H10.5625V38H6.5625ZM12.9625 40H16.9625V38H12.9625V40ZM19.3625 40H23.3625V38H19.3625V40ZM25.7625 40H29.7625V38H25.7625V40ZM32.1625 40H36.1625V38H32.1625V40ZM38.5625 40H42.5625V38H38.5625V40ZM6.5625 6C5.45793 6 4.5625 6.89543 4.5625 8V40C4.5625 41.1046 5.45793 42 6.5625 42H42.5625C43.6671 42 44.5625 41.1046 44.5625 40V8C44.5625 6.89543 43.6671 6 42.5625 6H6.5625Z",
    fill: "#2196F3",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieEditBlue);
export default __webpack_public_path__ + "static/media/movie_edit_blue.7ae14ba50dce275c4497ae7c33879c74.svg";
export { ForwardRef as ReactComponent };